export const PERMISSION_DEFS = {
  gerente_manager: [
    { category: "Info", perms: [{ key: "full_access", label: "Acceso total (igual que el dueño)" }] },
  ],
  gerente: [
    { category: "Tienda", perms: [{ key: "edit_settings", label: "Editar configuraciones" }] },
    { category: "Equipe", perms: [{ key: "manage_team", label: "Puede administrar el equipo" }] },
    { category: "Caixa", perms: [
      { key: "manage_cash", label: "Administrar e fechar os caixas" },
      { key: "blind_close_cash", label: "Cerrar la caja a ciegas" },
      { key: "include_cash_opening", label: "Incluir en la apertura de caja" },
      { key: "manage_cash_movements", label: "Administrar movimentaciones de caja" },
    ]},
    { category: "Pedidos", perms: [
      { key: "update_orders", label: "Puede actualizar pedidos" },
      { key: "cancel_orders", label: "Puede cancelar pedidos" },
      { key: "give_discount", label: "Puede dar descuento" },
      { key: "add_credit", label: "Puede adicionar crédito" },
      { key: "view_order_totals", label: "Puede ver los totales de los pedidos" },
      { key: "service_fee", label: "Tasa de servicio" },
    ]},
    { category: "Estoque", perms: [
      { key: "manage_supplies", label: "Puede administrar suministros" },
      { key: "move_stock", label: "Puede movimentar estoque" },
    ]},
    { category: "Financiero", perms: [
      { key: "view_financial_reports", label: "Puede ver relatórios financieros" },
      { key: "view_order_totals", label: "Puede ver totales en dashboard" },
      { key: "view_other_reports", label: "Puede ver relatórios no financieros" },
    ]},
    { category: "Pagos", perms: [
      { key: "accept_cash", label: "Puede aceptar dinero" },
      { key: "accept_debit", label: "Puede aceptar débito" },
      { key: "accept_credit", label: "Puede aceptar crédito" },
      { key: "accept_voucher", label: "Puede aceptar voucher" },
    ]},
    { category: "Assinatura", perms: [{ key: "view_subscription", label: "Puede visualizar la subscripción" }] },
  ],
  sirviente: [
    { category: "Pedidos", perms: [
      { key: "update_orders", label: "Puede actualizar pedidos" },
      { key: "cancel_orders", label: "Puede cancelar pedidos (con contraseña)" },
    ]},
    { category: "Mesas", perms: [
      { key: "manage_tables", label: "Puede atender mesas" },
      { key: "close_table", label: "Puede cerrar la cuenta de la mesa" },
      { key: "receive_payment", label: "Puede recibir pagos" },
    ]},
    { category: "Pagos", perms: [
      { key: "accept_cash", label: "Puede aceptar dinero" },
      { key: "accept_debit", label: "Puede aceptar débito" },
      { key: "accept_credit", label: "Puede aceptar crédito" },
    ]},
  ],
};
